// Marketing-side platform metadata. The marketing site doesn't talk to the
// social API — only the app does — so we re-export only the static lookup data.

export const PLATFORMS = [
  { id: "twitter", name: "Twitter / X", icon: "𝕏", color: "bg-black" },
  { id: "instagram", name: "Instagram", icon: "📷", color: "bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600" },
  { id: "facebook", name: "Facebook", icon: "f", color: "bg-blue-600" },
  { id: "linkedin", name: "LinkedIn", icon: "in", color: "bg-blue-700" },
  { id: "tiktok", name: "TikTok", icon: "♪", color: "bg-black" },
  { id: "youtube", name: "YouTube", icon: "▶", color: "bg-red-600" },
  { id: "reddit", name: "Reddit", icon: "r/", color: "bg-orange-600" },
  { id: "pinterest", name: "Pinterest", icon: "P", color: "bg-red-700" },
  { id: "threads", name: "Threads", icon: "@", color: "bg-black" },
  { id: "telegram", name: "Telegram", icon: "✈", color: "bg-sky-500" },
] as const;

export function getPlatformInfo(platformId: string) {
  return PLATFORMS.find((p) => p.id === platformId) || { id: platformId, name: platformId, icon: "?", color: "bg-gray-500" };
}
